import styled from 'styled-components'

import * as buttonStyles from '@bufferapp/ui/Button/style'

/**
 *
 */
export const Wrapper = styled.button`
  ${buttonStyles.ButtonBase}
  ${(prop) =>
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    buttonStyles[prop.variant || 'primary']}
  ${(prop) =>
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    buttonStyles[prop.size || 'medium']}
`
